import humps from 'humps'

export class ApiError {
  public messages
  public apiStatus
  public messagesArray
  public messagesString
  public baseResponse

  constructor(apiStatus, messages, baseResponse) {
    this.messages = messages
    this.apiStatus = apiStatus
    this.messagesArray = []
    this.messagesString = ''
    this.baseResponse = baseResponse

    try {
      messages.forEach((message, index) => {
        if (typeof message !== 'function') {
          message.forEach((item) => {
            this.messagesArray.push(`${index} ${item}`)
            this.messagesString = `${this.messagesString}
              ${index} ${item}`
          })
        }
      })
    } catch (error) {
      this.messagesArray = ['Server Error']
      this.messagesString = 'Server Error'
    }
  }
}

export class ApiResponse {
  public apiStatus
  public data
  public headers
  public meta

  constructor(apiStatus, data, headers, meta) {
    this.apiStatus = apiStatus
    this.data = humps.camelizeKeys(data)
    this.headers = headers
    this.meta = humps.camelizeKeys(meta)
  }
}
